import React, {useEffect} from 'react';
import './App.css';
import AssaySchedulerTime from "./AssaySchedulerTime";
import {Provider, useDispatch} from "react-redux";
import {setComplexId, setTheme, store} from "@cabinet-packages/redux";
import {setActionImg, setRegions, setTakeId} from "@cabinet-packages/redux/actions/actionsCreators";
import actionIMG from "medis/src/assets/images/promotionImages/action.jpg";
import {isLogin} from "@cabinet-packages/helpers";
import {ThemeProvider} from "@material-ui/core";
import {MuiPickersUtilsProvider} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import uk_utils from "date-fns/locale/uk";
import {BrowserRouter} from "react-router-dom";
import {ConfirmDialog, CustomDialog} from "@cabinet-packages/components";
import {AppStateProvider} from "@cabinet-packages/hooks";
import themeMaterialUI from "./settings/themeMaterialUI";

function App () {
  const dispatch = useDispatch();

  useEffect( ()=> {
    dispatch(setComplexId(75));
    dispatch(setTakeId(14));
    dispatch(setTheme(themeMaterialUI));
    dispatch(setActionImg(actionIMG));
    dispatch(setRegions());
    if (localStorage.getItem('activePatient') && !isLogin()) localStorage.removeItem('activePatient');
    if (localStorage.getItem('activePatientPhone') && !isLogin()) localStorage.removeItem('activePatientPhone');
  }, [dispatch]);


  return <MuiPickersUtilsProvider utils={DateFnsUtils} locale={uk_utils}>
      <AssaySchedulerTime dataPickers={true}/>
    </MuiPickersUtilsProvider>
}

function AppWrapper () {
  return (<ThemeProvider theme={themeMaterialUI}>
        <Provider store={store}>
          <BrowserRouter getUserConfirmation={(message, callback) => {
            CustomDialog(ConfirmDialog, {
              onConfirm: () => callback(true),
              onCancel: () => callback(false),
              text: message,
            }, false, themeMaterialUI);
          }}>
            <AppStateProvider>
              <App/>
            </AppStateProvider>
          </BrowserRouter>
        </Provider>
      </ThemeProvider>
  )
}

export default AppWrapper;
